import Address from '@/locations/models/address'
import Entity from '@/common/models/entity'
import Guid from '@/app/utils/guid'

export default class Tenant extends Entity {

  public firstName: string = ''
  public lastName: string = ''
  public company: string = ''
  public vat: string = ''
  public email: string = ''
  public isSmallBusiness: boolean = false
  public address = new Address()
  public canCreateGlobalCompetences = false

  public isEmpty() {
    return this.id == Guid.empty()
  }
}
